import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { setOperationHoursWeekDays } from '../../redux/actions/operationHoursActions';
import WeekDays from './WeekDays';
interface WDSIProps {
  title?: string;
  targetReducer: string;
}

export default function ToggleButtonsMultiple(props: WDSIProps) {
  const [formats, setFormats] = React.useState<string[]>(() => []);
  const dispatch: any = useDispatch();
  const reducer = props.targetReducer;
  const { weekDays } = useSelector((state: RootStateOrAny) => state[reducer]);
  const handleFormat = (
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ) => {
    if (newFormats.length >= 1) {
      setFormats(newFormats);
    }
  };

  useEffect(() => {
    dispatch(setOperationHoursWeekDays({ weekDays: [...formats] }));
  }, [formats, dispatch]);
  return (
    <>
      <Typography>{props.title}</Typography>
      <WeekDays weekDays={weekDays} handleFormat={handleFormat} />
    </>
  );
}
